import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Minus from '../../svgs/Minus';
import Plus from '../../svgs/Plus';

const TidalCountInputWrapper = styled.div`
  width: 100%;
  & > .label {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 8px;
    color: ${(props) => props.theme.colors.text[0]};
  }
  & > .input-row {
    display: grid;
    grid-template-columns: 1fr 86px 86px;
    grid-gap: 0 14px;
    @media only screen and (max-width: 370px) {
      grid-template-columns: 1fr;
      grid-gap: 8px 0;
    }
    & > input {
      height: 42px;
      border-radius: 10px;
      border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
      background-color: ${(props) => props.theme.colors.secondary};
      padding: 0 16px;
      width: 100%;
      &:focus {
        outline: 2px solid ${(props) => props.theme.colors.accent};
      }
      ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    & > .count-button {
      height: 42px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
    }
  }
`;

interface ITidalCountInput {
  label: string;
  placeholder: string;
  value: string;
  name?: string;
  defaultValue?: string;
  onBlur?: (e: any) => void;
  onChange?: (e: any) => void;
  onAction?: (e: string) => void;
}

const TidalCountInput = ({
  label,
  placeholder,
  value,
  name,
  defaultValue,
  onBlur,
  onChange,
  onAction,
}: ITidalCountInput): JSX.Element => {
  const [valueState, setValueState] = useState(defaultValue);

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return (
    <TidalCountInputWrapper>
      <p className="label">{label}</p>
      <div className="input-row">
        <input
          value={valueState}
          name={name}
          onChange={(e: any) => {
            onChange && onChange(e);
          }}
          onBlur={onBlur}
          type="number"
          placeholder={placeholder}
        />
        <button
          aria-label="plus"
          className="count-button"
          onClick={() => {
            if (parseInt(valueState) < 2000)
              setValueState((valueState) =>
                (parseInt(valueState) + 1).toString(),
              );
            onAction((parseInt(valueState) + 1).toString());
          }}
        >
          <Plus />
        </button>
        <button
          aria-label="minus"
          className="count-button"
          onClick={() => {
            if (parseInt(valueState) > 0)
              setValueState((valueState) =>
                (parseInt(valueState) - 1).toString(),
              );
            onAction((parseInt(valueState) - 1).toString());
          }}
        >
          <Minus />
        </button>
      </div>
    </TidalCountInputWrapper>
  );
};

export default TidalCountInput;
